module.exports = __webpack_public_path__ + "img/bootstrap.1e0ee1be.svg";